import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import {
  type AddRetailerRegionToOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdPostData,
  type AddRetailerRegionToOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdPostError,
  type AddRetailerRegionToOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdPostResponse,
  addRetailerRegionToOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdPost,
} from '../../generated';

export type AddRetailerRegionToOrganizationMutationVariables =
  AddRetailerRegionToOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdPostData['path'];

export type AddRetailerRegionToOrganizationMutation =
  AddRetailerRegionToOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdPostResponse;

export const useAddRetailerRegionToOrganizationMutation = <
  TError = AddRetailerRegionToOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdPostError,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      AddRetailerRegionToOrganizationMutation,
      TError,
      AddRetailerRegionToOrganizationMutationVariables,
      TContext
    >,
    'mutationKey' | 'mutationFn'
  >,
) => {
  return useMutation<
    AddRetailerRegionToOrganizationMutation,
    TError,
    AddRetailerRegionToOrganizationMutationVariables,
    TContext
  >({
    mutationKey: ['AddRetailerRegionToOrganization'],
    mutationFn: async ({ org_id, retailer_region_id }: AddRetailerRegionToOrganizationMutationVariables) => {
      const { data } = await addRetailerRegionToOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdPost({
        path: { org_id, retailer_region_id },
        throwOnError: true,
      });
      return data;
    },
    ...options,
  });
};

useAddRetailerRegionToOrganizationMutation.fetcher = (
  { org_id, retailer_region_id }: AddRetailerRegionToOrganizationMutationVariables,
  _headers?: RequestInit['headers'],
) => {
  return async () => {
    const { data } = await addRetailerRegionToOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdPost({
      path: { org_id, retailer_region_id },
      throwOnError: true,
    });
    return data;
  };
};
